import * as React from "react";
import {
  ColumnHelper,
  DeepKeys,
  DisplayColumnDef
} from "@tanstack/react-table";

import { ITerminology } from "src/library/utils";
import { IList } from "src/core/lists/api/lists.api";
import ScheduleStatusText from "src/core/lists/components/ScheduleStatusText";

/**
 * This function returns a reusable formated column definition for schedule status data to be used in Tanstack tables
 *
 * @param columnHelper
 * @param terminology
 * @returns column definition for schedule status data
 */
export const scheduleStatusColumn = <TData extends IList | undefined>(
  columnHelper: ColumnHelper<TData>,
  terminology: ITerminology
) => {
  return columnHelper.accessor("scheduleStatus" as DeepKeys<TData>, {
    id: "scheduleStatus",
    header: terminology.schedule.singular.text + "\n" + "Status",
    cell: info => {
      const list = info.row.original;

      if (list?.schedule) {
        if (list) {
          return (
            <ScheduleStatusText
              status={list.schedule.status}
              hasErrors={list.errors && !!list.errors.length}
            />
          );
        }
      }

      return "-";
    },
    enableSorting: false,
    enableColumnFilter: false,
    minSize: 100,
    meta: { style: { align: "left" } }
  } as DisplayColumnDef<TData>);
};
